import { Table } from '@tanstack/react-table';
import React from 'react';

import { IConnectWalletToPairRow } from 'types/tables/dex/connectWalletToPairRow';
import { TableCheckbox } from 'ui/Table/TableCheckbox/TableCheckbox';

interface IWalletAddressHeadProps {
  table: Table<IConnectWalletToPairRow>;
}

const WalletAddressHead: React.FC<IWalletAddressHeadProps> = ({ table }) => {
  return (
    <div className="checkbox-area">
      <TableCheckbox
        id="select-all-to-connect-to-dex-pair"
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
      <span>Wallet address</span>
    </div>
  );
};

export default WalletAddressHead;
